export default __webpack_public_path__ + "static/media/circle-arrow-top-left.9e159844.svg";